export const proposerOccupation = [ "Salaried",
"Self Employed",
"BUSINESS OWNER / MANAGER - Clerical",
"Retired",
 "Student",
"Housewife",
"Rentals",
 "Interest",
 "Investment",
 "Pension",
 "Others"]

export const ProposerIndustryType=[
    "Jewellery",
 "Import-Export",
"Mining",
 "Shipping",
"Scrap Dealing",
"Agriculture",
"Stock Broking",
"BFSI",
"Real Estate",
"Manufacturing",
"Antique dealer",
"Art dealer",
"Others"
]

export const ProposerOrganizationType = [
   " Government",
"Public Limited",
"Proprietor",
"Partner",
"Trust",
"HUF",
"Section 25 company"
]